import React from "react";

const ProjeDetayLoader = () => {
  return (
    <div className="p-3 bg-gray-100 rounded-2xl shadow-cardShadow animate-pulse">
      <div className="w-full h-96 bg-gray-100 rounded-2xl" />
    </div>
  );
};

export default ProjeDetayLoader;
